export type InvalidBoxProps = {
  className?: string;
  errors?: Array<{ id: number; label: string }>;
};
export const defaultProps = {
  className: '',
  errors: [],
};
